import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import styled, { tstyled } from '../theme';
import { ProjectTypeRenderer, IRenderProps } from '../models/ProjectType';
import AboutLogo from '../assets/about-logo.svg';
import UpArrow from '../assets/up-arrow.svg';

const Container = tstyled<{ visible: boolean }>(styled.div)`
  background-color: #fff;
  box-shadow: 0px 0px 15px rgba(134, 98, 30, 0.4);
  position: fixed;
  top: 0;
  width: 100%;
  transform: translateY(${props => (props.visible ? 0 : '-100%')});
  opacity: ${props => (props.visible ? 1 : 0)};
  contain: content;
  transition: ${props =>
    props.visible
      ? '0.2s ease-in-out transform, 0.1s ease-in-out opacity'
      : '0.2s ease-in-out transform, 0.3s ease-in-out opacity'};
  z-index: 2;
  will-change: opacity, transform;

  @media(min-width: ${props => props.theme.mobileBreakpoint}px) {
    top: auto;
    bottom: 0;
    transform: translateY(${props => (props.visible ? 0 : '100%')});
  }
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding: 20px 0;
  align-items: center;

  @media (max-width: ${props => props.theme.mobileBreakpoint - 1}px) {
    padding: 20px ${props => props.theme.mobilePadding}px;
  }

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    width: 65%;
  }
`;

const BreadcrumbContainer = styled.div`
  max-width: 72%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  > * {
    font-size: 12px;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    > * {
      font-size: 14px;
      margin-right: 10px;
    }
  }

  @media (min-width: 1800px) {
    > * {
      font-size: 0.8vw;
    }
  }
`;

const LinkDesktop = styled.div`
  @media (max-width: ${props => props.theme.mobileBreakpoint - 1}px) {
    display: none;
  }

  a {
    cursor: pointer;
    color: ${props => props.theme.color.body2};
    display: inline-block;
    text-decoration: none;

    &:hover {
      transform: scaleY(-1);
    }
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;

const LinkMobile = styled.div`
  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    display: none;
  }

  img {
    height: 16px;
  }

  a {
    display: flex;
    cursor: pointer;
    text-decoration: none;
    color: ${props => props.theme.color.body2};
  }
`;

function render(
  props: IRenderProps & { projectSlug: string; projectType: string }
) {
  const { projectType, projectSlug } = props;
  let name: string;
  if (!props.projectMap.has(projectSlug)) {
    name = '';
  } else {
    name = props.projectMap.get(projectSlug)!.fields.name;
  }

  return (
    <HeaderScrollNotification
      projectType={
        projectType ? props.typeMap.get(projectType)!.fields.name : ''
      }
      projectName={name}
    />
  );
}

function Wrapper(
  props: RouteComponentProps<{ projectSlug: string; projectType: string }>
) {
  return (
    <ProjectTypeRenderer
      projectSlug={props.match.params.projectSlug}
      projectType={props.match.params.projectType}
      render={render}
    />
  );
}

interface IProps {
  projectType: string;
  projectName: string;
}
interface IState {
  visible: boolean;
}
class HeaderScrollNotification extends React.Component<IProps, IState> {
  state: IState = {
    visible: false,
  };

  lastPosition = 0;

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  shouldComponentUpdate(nextProps: IProps, nextState: IState) {
    return (
      nextProps.projectType !== this.props.projectType ||
      nextProps.projectName !== this.props.projectName ||
      nextState.visible !== this.state.visible
    );
  }

  onScroll = () => {
    requestAnimationFrame(this.determineFixed);
  };

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  determineFixed = () => {
    const position = window.scrollY;

    const shouldBeFixed = position > 500 && this.lastPosition > position;
    if (shouldBeFixed !== this.state.visible) {
      this.setState({ visible: shouldBeFixed });
    }
    this.lastPosition = position;
  };

  render() {
    return (
      <Container visible={this.state.visible}>
        <Inner>
          <div>
            <LinkDesktop>
              <Link to="/about">About Troy</Link>
            </LinkDesktop>
            <LinkMobile>
              <Link to="/about">
                <img src={AboutLogo} />
              </Link>
            </LinkMobile>
          </div>
          <BreadcrumbContainer>
            <span>{this.props.projectType}</span>
            <span>&gt;</span>
            <span>{this.props.projectName}</span>
          </BreadcrumbContainer>
          <div>
            <LinkDesktop onClick={this.scrollToTop}>
              <a>Back to the Top</a>
            </LinkDesktop>
            <LinkMobile onClick={this.scrollToTop}>
              <a>
                <img src={UpArrow} />
              </a>
            </LinkMobile>
          </div>
        </Inner>
      </Container>
    );
  }
}

export default withRouter(Wrapper);



// WEBPACK FOOTER //
// ./src/components/HeaderScrollNotification.tsx